import React from 'react';
import {useSelector} from 'react-redux';
import {Input, Dropdown} from 'semantic-ui-react';
import {uniqBy, map} from 'lodash';

export const Filter = ({column}) => {
  return (
    <div>
      {column.canFilter && column.render('Filter')}
    </div>
  );
};

export const DefaultColumnFilter = ({
  'column': {
    filterValue,
    setFilter,
  },
}) => {
  return (
    <Input
      value={filterValue || ''}
      onChange={(e) => {
        setFilter(e.target.value || null);
      }}
    />
  );
};

const renderOption = (element, index) => {
  const name = element.name.toUpperCase();
  return {'key': index + 1, 'text': name, 'value': name};
};

const selectOptions = (list) => {
  const opt = map(list, (element, index) => renderOption(element, index));
  opt.unshift({'key': 0, 'text': 'TODOS', 'value': 'TODOS'});
  return opt;
};

export const SelectColumnFilter = ({
  'column': {filterValue, setFilter, id},
}) => {
  const vehiclesRaw = useSelector((state) => state.waitHappyVehicles.list);
  const vehiclesCar = vehiclesRaw.map((veh) => ({'name': veh.car}));
  const vehiclesList = uniqBy(vehiclesCar, 'name');
  const dealerNames = vehiclesRaw.map((veh) => ({'name': veh.dealer}));
  const dealerList = uniqBy(dealerNames, 'name');
  const options = id === 'car' ? vehiclesList : dealerList;

  return (
    <Dropdown
      className='filter-selection'
      selection
      defaultValue='TODOS'
      value={filterValue}
      options={selectOptions(options)}
      onChange={(e, {value}) => {
        const currentValue = value !== 'TODOS' ? value : null;
        setFilter(currentValue);
      }}
    />
  );
};
